import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mt-6">
          Sayfa bulunamadı
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg text-foreground-600">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          Anasayfaya dön
        </Link>
      </div>
    </div>
  );
}